import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { createSelector } from 'reselect';
import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';

const NONE_GUID = '00000000-0000-0000-0000-000000000000';

const getDisplayName = (appliedFilters, users) => {
  if (appliedFilters.length === 0) {
    return <FormattedMessage defaultMessage='Assignee' description='filterOptions.assignee' id='OhVCFJ' />;
  }
  if (appliedFilters.length > 1) {
    return <FormattedMessage defaultMessage='(Multiple Users)' description='filterOptions.multipleUsers' id='VRtn8v' />;
  }
  const [filter] = appliedFilters;
  if (filter.criterionArgumentValue === NONE_GUID) {
    return <FormattedMessage defaultMessage='Unassigned' description='filterOptions.unassigned' id='tRhvE7' />;
  }

  const matchingUser = users.find((user) => user.userId === filter.criterionArgumentValue);
  if (!matchingUser) {
    return <FormattedMessage defaultMessage='Assignee' description='filterOptions.assignee' id='OhVCFJ' />;
  }
  return matchingUser.name;
};

const getUserName = (users, userId) => {
  const user = users.find((u) => u.userId === userId);
  if (!user) {
    return;
  }
  return user.name;
};

const userNameSelector = createSelector(
  (users) => users,
  (_, currentUserId) => currentUserId,
  getUserName,
);

const displayNameSelector = createSelector(
  (appliedFilters) => appliedFilters,
  (_, users) => users,
  getDisplayName,
);

const mapStateToProps = (state, ownProps) => {
  const users = Global.selectSellerUsers(state);
  const currentUserId = Global.selectUserCurrentUserId(state);
  const appliedFilters = Global.selectOrdersFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });
  const isUserLocked = Global.selectUseruserHasOrderViewRestriction(state);
  const displayContent = isUserLocked ? userNameSelector(users, currentUserId) : displayNameSelector(appliedFilters, users);
  return {
    isLocked: isUserLocked,
    isSelected: !!appliedFilters.length,
    displayContent,
  };
};

export const AssignedTo = connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
